<!-- NOTICE: KAPTION-INTEGRATION -->
<!-- Circular SVG flag component for displaying country flags based on language codes -->
<!--
  TAILWIND SAFELIST - These classes must be listed so Tailwind JIT includes them:
  i-circle-flags-sa i-circle-flags-cz i-circle-flags-dk i-circle-flags-de
  i-circle-flags-gr i-circle-flags-gb i-circle-flags-es i-circle-flags-ir
  i-circle-flags-fi i-circle-flags-fr i-circle-flags-il i-circle-flags-in
  i-circle-flags-id i-circle-flags-it i-circle-flags-jp i-circle-flags-kr
  i-circle-flags-my i-circle-flags-nl i-circle-flags-no i-circle-flags-pl
  i-circle-flags-br i-circle-flags-ru i-circle-flags-se i-circle-flags-th
  i-circle-flags-tr i-circle-flags-vn i-circle-flags-cn
-->
<script setup>
import { computed } from 'vue';
import { getCountryCode } from 'dashboard/constants/kaptionLanguages';

const props = defineProps({
  /**
   * Two-letter language code (e.g., 'en', 'es', 'pt')
   * Will be mapped to corresponding country code for flag display
   */
  languageCode: {
    type: String,
    required: true,
  },
  /**
   * Size class for the flag (e.g., 'size-3', 'size-4', 'size-5')
   * Defaults to size-4 (16px)
   */
  size: {
    type: String,
    default: 'size-4',
  },
});

const countryCode = computed(() => getCountryCode(props.languageCode));

const flagClass = computed(() => {
  if (!countryCode.value) return null;
  return `i-circle-flags-${countryCode.value}`;
});
</script>

<!-- eslint-disable vue/no-bare-strings-in-template -->
<template>
  <span
    v-if="flagClass"
    class="inline-block flex-shrink-0"
    :class="[flagClass, size]"
    role="img"
    :aria-label="`Flag for ${languageCode}`"
  />
  <span v-else class="inline-flex items-center justify-center" :class="size">
    🌐
  </span>
</template>
